
import * as defaultImport from "@splunk/visualization-schemas";
export * from "@splunk/visualization-schemas";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
